import React from 'react';
import ClaireHutchinson from '../../assets/images/ClaireHutchinson.jpg';
import { Container, Col, Row } from 'react-bootstrap';
import './Bio.css';

function Bio() {
  return (
<div className="mainContent">
<h1>Bio of Claire Hutchinson, M.A.</h1>
<h2>WRITER</h2>
<Container>
  <Row>
    <Col md={3} className="flushLeft"><img src={ClaireHutchinson} alt="Portrait of Claire Hutchinson" /></Col>
    <Col>
        <p>Claire Hutchinson (B.A. (Honors) English, University of Winnipeg; M.A. English, University of Manitoba; Cert. Feature Film Writing, Cert. Professional Program in Screenwriting, UCLA) is a produced and award-winning screenwriter, script analyst, film festival judge, speaker, and producer. 
          She is the screenwriter of the film "Lucky's Treasure", starring Michael Ironside ("Top Gun", "Total Recall"), Delaney, and J.T. Neal. It was distributed by Pureflix and Universal Studios in 2017. 
          She is also the co-producer, writer, and director of the short film, “Living the Dream,” which won third place in the shorts category at the Winnipeg Real to Reel Film Festival in 2019. 
          Her WWI script, "The Czar's Letters", won first place in the Winnipeg Real to Reel Film Festival and was an Official Selection of ICFF in 2019. 
          Her script on the life of British journalist Dan Wooding entitled "Twenty-Six Lead Soldiers" was an official selection of the 2019 Life Fest Film Festival and an Official Nominee of ICFF. 
          Other Official Selections of ICFF include “Status Update” (2022) and “When We Were JC Eaton” (2023). The latter script also was the Grand Prize Winner at the Winnipeg Real to Reel Film Festival (2023).</p>

        <p>Her credits include "Tomorrow" (2018), "The Thought of You" (2018), "Living the Dream"
        (2018, co-producer, director, writer), "Lucky's Treasure" (2017) and "Waves" (2015). Claire
        also judges ICVM Scene Shop, 168 Film Festival, 168 Write of Passage Screenwriting
        Competition, Great Lakes Christian Film Festival and Life Fest Film Festival.</p>

        <ul class="links">
          <li>IMDB: <a href="https://pro-labs.imdb.com/name/nm7592199/" target="_blank" rel="noopener noreferrer">https://pro-labs.imdb.com/name/nm7592199/</a></li>


        <li><a href="http://www.clairehutchinson.net" target="_blank" rel="noopener noreferrer">www.clairehutchinson.net</a></li>
        <li><a href="http://www.ambassadorcommunications.biz" target="_blank" rel="noopener noreferrer">www.ambassadorcommunications.biz</a></li></ul>
    </Col>
  </Row>
</Container>
  
<h2>SCRIPT ANALYST</h2>
<p>Claire has consulted for companies such as Du More Films (whose film "Vincent's Vow" won Best Picture at ICFF in 2021), Living Water Media, Visual Productions, CV Films, 
and Abel Company (video endorsement): <a href="https://www.youtube.com/watch?v=6USCI5Os5CM&feature=share" target="_blank" rel="noopener noreferrer">https://www.youtube.com/watch?v=6USCI5Os5CM&feature=share</a></p>

<h2>PUBLISHER</h2>
<p>Under her company Ambassador Communications, Claire has been publishing the Christian Screenwriters' Newsletter since 2005. The newsletter has a subscriber base of over 550 screenwriters, producers and others interested in faith-based filmmaking. To subscribe, please send an email to <a href="mailto:info@ambassadorcommunications.biz">info@ambassadorcommunications.biz</a>.</p>
<h2>CONTESTS</h2>
<p>Claire is the Founder of the Faith and Values Screenwriting Competition, a competition geared to finding the best faith-based and family oriented screenplays for production.  The first place winner of this competition went on to sell his script to Believe Pictures (Michael Landon, Jr. and Brian Bird). After Claire critiqued the second place winner’s script, the second place winner later rewrote the script, and in 2010, submitted the script to the Kairos Prize Screenwriting Competition and won 2nd place and $15,000. (Contest is not in operation)</p>
<h2>SCREENPLAYS PRODUCED</h2>
<ul>
<li>2018 &#8212; "Tomorrow" &#8212; Writer, for Gary Emrick Productions"</li>
<li>2018 &#8212; "Living the Dream" &#8212; Writer, co-producer, director, production co-ordinator. Released in April of 2018</li>
  <li>2017 &#8212; "The Ring" &#8212; Executive Producer.</li>
  <li>2017 &#8212; "The Thought of You" for Gary Centrone of CV Films. I was the script consultant.</li>
  <li>2017 &#8212; "Lucky's Treasure" for Shane Hawks of Grace Alone Films. I was the screenwriter. The film is distributed by Pureflix Entertainment ("God's Not Dead," and "The Case for Christ") and Universal Studios, and stars Michael Ironside, Delaney, and J.T. Neal.</li>
  <li>2015 &#8212; "Waves" for Gary Centrone of CV Films. I was the script consultant. The film was an official selection of Roma Cinemadoc and the Los Angeles Cinefest. It was named Best of the Fest by the Inspired Faith Film Festival.</li>
  <li>2011 &#8212; "The Third Day" for Marc Villiger of Visual Productions. I did a polish on the script and the film about the resurrection of Jesus. The film is distributed by Vision Video. The film was nominated in 2013 for five Crown Awards, including Best Picture and Best International Film.</li>
</ul>
<h2>AWARDS AND HONORS</h2>
<ul>
  <li>2023 &#8212; "When We Were JC Eaton" &#8212; Grand Prize Winner, Winnipeg Real to Reel Film Festival and Official Selection, ICFF</li>
  <li>2022 &#8212; "Status Update" &#8212; Official Selection, ICFF</li>
  <li>2021 &#8212; "Twenty-Six Lead Soldiers" &#8212; Official Nominee, ICFF</li>
  <li>2019 &#8212; "Twenty-Six Lead Soldiers" &#8212; Official Selection, Life Fest Film Festival</li>
  <li>2019 &#8212; "The Czar's Letters" &#8212; Grand Prize Winner, Winnipeg Real to Reel Film Festival and Official Selection, ICFF</li>
  <li>2017 &#8212; "Heroes from Heaven" &#8212; Winner of the Christian Film Festival: Best Writer, Best Script, Best Script Fan Favorite</li>
  <li>2013 &#8212; "The Third Day" &#8212; Nominated for five ICVM Crown Awards, including Best International Film and Best Picture</li>
  <li> 2012 &#8212; "The Doctor" &#8212; 1st Place in the Winnipeg Real to Reel Film Festival
    News Article:<br /><a href="http://www.oldassistnews.net/Stories/2012/s12040017.htm" target="_blank" rel="noopener noreferrer">www.oldassistnews.net/Stories/2012/s12040017.htm</a> </li>
  <li> 2011 &#8212; "The Doctor" &#8212; 1st Place in the Life Fest Film Festival held in L.A., CA
    News Article:<br /><a href="http://www.oldassistnews.net/stories/2011/s11050089.htm" target="_blank" rel="noopener noreferrer">www.oldassistnews.net/stories/2011/s11050089.htm</a>. </li>
  <li>2009 &#8212; "That's Amore" &#8212; Top Ten Finalist in the Mafia Short Screenplay Competition sponsored by Pavaline Studios </li>
  <li>2006 &#8212; "Harry and Marge" (Play Version) &#8212; 3rd Place in the Humana Festival of New American Plays for Actors Theatre of Louisville in Louisville, KY </li>
  <li>2005-2008 &#8212; "The Sisterhood of Women Helping Women," "Caleb the Colt" and "The Coat" &#8212; Quarterfinalist and Special Mention in the American Gem Short Screenplay Competition </li>
</ul>
<h2>SCRIPT CONSULTATION HIGHLIGHTS</h2>
<ul>
  <li>2021 &#8212; I did a book into screenplay adaptation of Philip Hardy's novel, "Lone Oak," which is now in pre-production. The trailer for the movie was an Official Nominee of ICFF (2023).</li>
  <li>2021 &#8212; I consulted on Du More Films' script, "Vincent's Vow," which went on to win Best Picture at ICFF.</li>
  <li>2019 &#8212; Judge of the screenplays for the Great Lakes Christian Film Festival</li>
  <li>2014-present &#8212; Judge of the ICVM Crown Awards</li>
  <li>2013-present &#8212; Judge of the 168 Film Festival</li>
  <li>2012-present &#8212; Development Executive for the Write of Passage Screenwriting Competition sponsored by 168 Film Project</li>
  <li>2012-present &#8212; Judge of the Life Fest Film Festival, LA, CA</li>
  <li>2007 &#8212; I consulted on the script "The Shoe Box," which was the second-place winner of my Faith and Values Screenwriting Competition. In 2010, after the writer rewrote the script, she entered it in the Kairos Prize and won 2nd Place and $15,000.</li>
</ul>
<h2>OTHER SCREENPLAYS/PLAYS WRITTEN</h2>
<h3>PLAYS</h3>
<ul>
  <li>"Hadleyburg" &#8212; Musical play adaptation based on Mark Twain's short story, "The Man that Corrupted Hadleyburg."</li>
  <li>"The Best Christmas Ever" &#8212; Play adaptation of tract entitled "The Cobbler."</li>
  <li>"Harry and Marge" &#8212; Play adaptation of screenplay, "Harry and Marge."</li>
  <li>"The Coat" &#8212; Play adaptation of screenplay, "The Coat."</li>
  <li>"Caleb the Colt" &#8212; Musical play adaptation of screenplay, "Caleb the Colt."</li>
</ul>
<h3>SCREENPLAYS</h3>
<ul>
  <li>"The One Not Chosen" &#8212; 5-part ½ hour TV drama series</li>
  <li>"When We Were JC Eaton" &#8212; Drama with co-writer Ann I. Goldfarb</li>
  <li>"The Best Christmas Ever" &#8212; Short Drama</li>
  <li>"Lone Oak" &#8212; Western</li>
  <li>"Crosscurrents" &#8212; Drama</li>
  <li>"Limo Driver" &#8212; Drama based on true events</li>
  <li>"Tomorrow" &#8212; Pro-life Short Drama</li>
  <li>"The Czar's Letters" &#8212; Historical Drama</li>
  <li>"Twenty-Six Lead Soldiers: The Dan Wooding Story" &#8212; Drama, 6-part miniseries</li>
  <li>"Heroes from Heaven" &#8212; Sci-Fi</li>
  <li>"Living the Dream" &#8212; Comedy</li>
  <li>"Skipper and Babe: Saving Lives" &#8212; Animation</li>
  <li>"Lucky's Treasure" &#8212; Drama</li>
  <li>"The Mystery of the Christmas Stars" &#8212; Drama Live Action/Animation</li>
  <li>"For the Love of Freedom" &#8212; Documentary</li>
  <li>"The Magic Pen" &#8212; Comedy</li>
  <li>"The Turkey and the Hen: A Thanksgiving Love Story" &#8212; Animation</li>
  <li>"The Star of Bethlehem" &#8212; Animated Musical</li>
  <li>"Crocodile Love" &#8212; Animated Musical</li>
  <li>"Senior Stuntman: Episode 1: Be Brave, Be Strong" &#8212; 1 Hour TV Action-Comedy</li>
  <li>"Flat Rock Indiana: Episode 1: The Treasure of Flat Rock" &#8212; 1/2 Hour TV Comedy</li>
  <li>"Status Update" &#8212; Romantic Comedy</li>
  <li>"Cell Phone Addict" &#8212; Romantic Comedy</li>
  <li>"The Battle for the Kingdom" &#8212; Fantasy</li>
  <li>"Supermom" &#8212; Sci-Fi Action Adventure/Comedy</li>
  <li>"Flower Power" &#8212; Children's Animation</li>
  <li>"The Woman at the Well" &#8212; Religious Period Drama</li>
  <li>"Finding Mary" &#8212; Drama </li>
  <li>"I'm Worth the Wait" &#8212; Short Drama </li>
  <li>"Caleb the Colt" &#8212; Animated Musical</li>
  <li>"Harry and Marge" &#8212; Drama</li>
  <li>"Manitoba Crime Scenes" &#8212; Crime Drama Feature and Series</li>
</ul>
<h2>TEACHING/SPEAKING</h2>
<ul>
  <li>2022 &#8212; Speaker, "Theme in Screenwriting," ICVM</li>
  <li>2021 &#8212; Speaker, Women in Leadership Panel, ICVM</li>
  <li>2019 &#8212; Instructor at Phoenix Screenwriters' Association: three-part course
        on The Elements of Screenwriting: Putting It All Together.</li>
  <li>2018 &#8212; Speaker at the Christian Women in Media Association: 5 Ways to
Make Your Script Stand Out.</li>
  <li>2017 &#8212; Speaker at the SoCal Christian Writers' Conference at Biola University: Continuing Session on Screenwriting and critiquing participants' writing.</li>
  <li>2017 &#8212; Speaker at Library Event: Claire Hutchinson's Screenwriting Career and "Lucky's Treasure"</li>
  <li>2016 &#8212; Speaker with Terry Porter, WGA Agent, at Temple of Praise Arizona:<br />
  Topic: The Christian Film Movement: Our Role and the Church's Role.</li>
  <li>2015 &#8212; Speaker at Trinity Bible Church:<br />
  Topic: The Christian Film Movement: My Role in it and the Church's Role in it.</li>
  <li>2015 &#8212; Speaker at the Phoenix Screenwriters' Association:<br />
  Topic: Succeeding as a Screenwriter Outside of Hollywood.</li>
  <li>1987-1990 &#8212; University of Manitoba &#8212; Lecturer in English Composition.</li>
</ul>
<h2>EDUCATION</h2>
<ul>
  <li>2004-2005  &#8212; UCLA &#8211; Certificate in Professional Program in Screenwriting </li>
  <li>2002-2004  &#8212; UCLA &#8211; Certificate in Feature Film Writing </li>
  <li> 1994 	&#8212; University of Manitoba &#8211; Master of Arts (English)</li>
  <li>1987   &#8212; University of Winnipeg &#8211; Bachelor of Arts (Honours) English</li>
</ul>
</div>
  )
}

export default Bio;
